export default {
	sec_10: {
		title: {
			one: '国際規格',
			two: 'ウォレット使用',
		},
		desc: {
			one: 'セキュリティにセキュリティをかけた独自ウォレット',
			two: '外部ウォレット業者じゃなく独自開発ウォレット',
		},
		btn: {
			one: '資産を送る',
			two: 'アプリダウンロード',
		},
	},
	sec_12: {
		title: {
			one: '国際規格に合わせた',
			two: 'LEVEL 2 ',
			three: '以上のセキュリティ',
		},
		desc: {
			one: 'もう一度のセキュリティを施し',
			two: 'ハッキングを完璧に防ぎます。',
		},
	},
	sec_11: {
		one: {
			title: {
				one: '個人キーが 発生しません。',
			},
			desc: {
				one: '管理者及びDBハッキングが入っても',
				two: '個人キーが無くハッキングが難しいです。',
			},
		},
		two: {
			title: {
				one: 'ウォレットとはお客様の金庫同様です。',
			},
			desc: {
				one: '私たちJPWORLDPAYは独自ウォレットを制作後、',
				two: 'セキュリティにセキュリティを重ねたウォレットの為ハッキング対応に最適化されていてセキュリティに関しては自信をもっています。',
			},
		},
	},
};
